import { render } from "./custom-button.vue?vue&type=template&id=6d9c5f7a"
import script from "./custom-button.vue?vue&type=script&lang=js"
export * from "./custom-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__